<template>
  <div class="quiz-layout">
    <div class="row no-gutters">
      <div class="col-md-8">
        <div class="quiz-layout__content">
          <div class="quiz-layout__step">
            <span class="quiz-layout__active"><slot name="active"></slot></span> / <slot name="length"></slot>
          </div>

          <slot></slot>

          <div class="quiz-layout__footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
      <div class="col-md-4" v-if="!isMobile">
        <div class="quiz-layout__picture">
          <slot name="image"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isMobile () {
      return this.$mq.resize && this.$mq.below(this.$mv.md)
    }
  }
}
</script>

<style lang="scss" scoped>
.quiz-layout {
  background: $white;
  box-shadow: 0 0 14px 0 rgba($black, .12);

  @include media-breakpoint-up(md) {
    overflow: hidden;
    min-height: 370px;
  }

  &__content {
    padding: 30px;

    @include media-breakpoint-up(md) {
      padding: 30px 12px 30px 50px;
    }
  }

  &__step {
    @include font-size($font-size-lg);
    color: $theme-gray-700;
    font-weight: 600;
    margin-bottom: 20px;
  }

  &__active {
    @include font-size(36px);
    color: $theme-red-100;
  }

  &__footer {
    margin-top: 30px;
    text-align: center;
  }

  &__picture {
    position: absolute;
    top: 0;
    left: 0;
  }

  &__image {
    @include img-fluid;
  }
}
</style>
